import { render } from "./ResponseEventsPage.vue?vue&type=template&id=0e143e3b"
import script from "./ResponseEventsPage.vue?vue&type=script&lang=js"
export * from "./ResponseEventsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__